/* eslint-disable react/prop-types */
import { Box, Button } from "@mui/material";
import React from "react";
import { OTP_LEN } from "../../contants";
import { createArrayByLen, debounce } from "../../utils/helper";
import Modal from "../common/Modal/Modal";
import styles from "./OTPVerification.styles";

function InputPinSingleDigit({ id }) {
  const handleKeyUp = (e, nextID) => {
    const keyId = e.keyCode;
    switch (keyId) {
      case 8:
        if (nextID - 2 <= 0) return;
        document.getElementById(`digit${nextID - 2}`).focus();
        break;
      default:
        if (nextID > 6) return;
        document.getElementById(`digit${nextID}`).focus();
        break;
    }
  };
  return (
    <input
      type="text"
      style={styles.digitContainer}
      id={`digit${id}`}
      name={`otp-${id}`}
      placeholder="_"
      maxLength="1"
      onKeyUp={(e) => handleKeyUp(e, id + 1)}
    />
  );
}

export default function OTPVerification({ visible, onClose, onSubmit }) {
  return (
    <Modal open={visible} onClose={onClose}>
      <form style={styles.container} onSubmit={debounce(onSubmit)}>
        <Box p="30px" style={styles.cntentBox}>
          <Box style={styles.headingText}>Enter OTP</Box>
          <Box style={styles.subheadingText}>
            OTP Sent on members Registered Number
          </Box>
          <Box
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            {createArrayByLen(OTP_LEN).map((_, index) => (
              <InputPinSingleDigit id={index + 1} />
            ))}
          </Box>
          <Box style={styles.OtpAgainText}>Send OTP Again</Box>
          <Box>
            <Button
              variant="contained"
              type="submit"
              style={styles.submitButton}
            >
              Submit
            </Button>
          </Box>
        </Box>
      </form>
    </Modal>
  );
}
